import { icons } from './constant';

// ==============================|| EMPLOYEE MENU ITEMS ||============================== //

const employee = {
	id: 'employee_master',
	title: 'Employee',
	type: 'collapse',
	icon: icons.IconEmployees,
	children: [
		{
			id: 'departments',
			title: 'Departments',
			type: 'item',
			url: '/departments',
			icon: icons.AccountBalanceOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'roles',
			title: 'Roles',
			type: 'item',
			url: '/roles',
			icon: icons.IconRole,
			breadcrumbs: true,
		},
	],
};

export default employee;
